import ahoy from "ahoy.js"
import { AnalyticsProvider, AnalyticsEvent } from "../types"

export class AhoyProvider implements AnalyticsProvider {
  constructor() {
    this.initialize()
  }

  private initialize(): void {
    ahoy.configure({
      visitsUrl: "/ahoy/visits",
      eventsUrl: "/ahoy/events",
      // withCredentials is true by default when using cookies
      visitParams: this.getVisitParams,
      eventParams: this.getEventParams,
    })
  }

  private getVisitParams(): Record<string, any> {
    return {
      referrer: document.referrer,
      landing_page: window.location.href,
      screen_width: window.screen.width,
      screen_height: window.screen.height,
    }
  }

  private getEventParams(): Record<string, any> {
    return {
      page: window.location.pathname,
      url: window.location.href,
    }
  }

  trackEvent(event: AnalyticsEvent): void {
    ahoy.track(event.name, event.properties || {})
  }

  identify(userId: string, properties?: Record<string, any>): void {
    ahoy.configure({
      visitorId: userId,
    })

    if (properties) {
      ahoy.track("user.identify", properties)
    }
  }

  reset(): void {
    ahoy.reset()
  }
}
